import HistoriaImg from "../../assets/img/nosotros.png";

function Header() {
  return (
    <main>
      {/* 🔥 HERO MÁS RESPIRADO ARRIBA Y ABAJO */}
      <div className="relative px-6 lg:px-8">
        <div className="mx-auto max-w-7xl py-16 lg:py-24">
          
          {/* GRID */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* 📝 TEXTO */}
            <div className="max-w-2xl">
              
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mb-6">
                Historia de la Fundación Arduvi
              </h1>

              <div className="text-base lg:text-lg leading-7 lg:leading-8 text-gray-800 space-y-4">
                
                <p>
                  En Colombia se estima que 2 millones 588 mil personas tienen algún tipo de discapacidad y tan solo un 2.6% de estas personas son vinculadas laboralmente a una empresa.                  Esta realidad y una experiencia vivida en un semáforo conmovió tanto a Arvey Duque Villamizar y a su hija Dayana Duque Espinosa a crear la Fundación Arduvi con el fin de contribuir a la transformación de las vidas de personas con condiciones especiales, migrantes, población vulnerable y en riesgo social.

                </p>

                <p>
                  Un espacio donde los límites se superen con el corazón y permitan una verdadera inclusión con amor.                  Con esa misma motivación, crearon Café Arduvi, el cual se ha convertido en orgullo no solo familiar sino de Cúcuta, siendo el primer café en Latinoamérica donde más del 80% de sus trabajadores son personas con alguna condición especial, brindándoles una vida digna al igual que a sus familias.

                </p>


              </div>
            </div>

            {/* 🖼️ IMAGEN */}
            <div className="flex justify-center">
              <img
                src={HistoriaImg}
                alt="Historia Fundación Arduvi"
                className="
                  w-full
                  max-w-sm
                  lg:max-w-md
                  xl:max-w-lg
                  object-contain
                "
              />
            </div>

          </div>
        </div>
      </div>
    </main>
  );
}

export default Header;